import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageClass } from '../../helpers/local-storage-helper';
import { ApiResponseSuccess } from '../../types/core/api-response.type';
import {
  ITenantConfiguration,
  TenantConfiguration,
} from '../../types/core/tenant-configuration.type';

const endpoints = {
  globalApplicationConfiguration: '/application-configuration/global',
  updateTenantConfiguration: '/common/tenant-configuration',
};

@Injectable({ providedIn: 'root' })
export class TenantConfigurationService {
  private readonly http = inject(HttpClient);
  private configuration: TenantConfiguration | null = null;

  private setConfiguration(config: TenantConfiguration) {
    this.configuration = config;
  }

  get config() {
    return this.configuration;
  }

  getGlobalApplicationConfiguration(): Observable<TenantConfiguration> {
    const url = `${environment.baseApiRoute}${endpoints.globalApplicationConfiguration}`;

    return this.http.get<ApiResponseSuccess<ITenantConfiguration>>(url).pipe(
      map((response) => new TenantConfiguration(response.data)),
      tap((config: TenantConfiguration) => {
        LocalStorageClass.setTenantIdentifier(config.tenant);
        this.setConfiguration(config);
      })
    );
  }
}
